import ErrorIcon from "@mui/icons-material/ErrorOutline";
import { Box, Card, CardContent, Typography } from "@mui/material";
import type React from "react";

interface ErrorCardProps {
  message?: string;
}

export const ErrorCard: React.FC<ErrorCardProps> = ({ message }) => {
  return (
    <Card sx={{ padding: 2, textAlign: "center" }}>
      <CardContent>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginBottom: 1 }}
        >
          <ErrorIcon color="error" sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h5" color="error" fontWeight={600} gutterBottom>
          Error
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Something went wrong
        </Typography>
        {message && (
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ marginTop: 1 }}
          >
            {message}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
